import React, { useState, useEffect } from 'react';
import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  Twitter as TwitterIcon,
} from '@mui/icons-material';

import FormButton from '../../../components/common/stories/FormButton';

const SocialLinks = ({ website, onUpdate, isSaving }) => {
  const [facebook, setFacebook] = useState(website?.social?.facebook || '');
  const [instagram, setInstagram] = useState(website?.social?.instagram || '');
  const [twitter, setTwitter] = useState(website?.social?.twitter || '');

  useEffect(() => {
    setFacebook(website?.social?.facebook || '');
    setInstagram(website?.social?.instagram || '');
    setTwitter(website?.social?.twitter || '');
  }, [website]);

  const handleSave = async () => {
    await onUpdate({
      social: {
        facebook,
        instagram,
        twitter,
      },
    });
  };

  return (
    <div className="settings-form">
      <div className="form-section">
        <h4 className="form-section-title">Social Media Links</h4>
        <p className="helper-text">
          Add your social media profile URLs. These will be displayed on your public website.
        </p>

        <div className="social-input-row">
          <div className="icon" style={{ background: '#1877f2', color: 'white' }}>
            <FacebookIcon />
          </div>
          <input
            type="url"
            placeholder="https://facebook.com/yourpage"
            value={facebook}
            onChange={(e) => setFacebook(e.target.value)}
          />
        </div>

        <div className="social-input-row">
          <div className="icon" style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)', color: 'white' }}>
            <InstagramIcon />
          </div>
          <input
            type="url"
            placeholder="https://instagram.com/yourprofile"
            value={instagram}
            onChange={(e) => setInstagram(e.target.value)}
          />
        </div>

        <div className="social-input-row">
          <div className="icon" style={{ background: '#1da1f2', color: 'white' }}>
            <TwitterIcon />
          </div>
          <input
            type="url"
            placeholder="https://twitter.com/yourhandle"
            value={twitter}
            onChange={(e) => setTwitter(e.target.value)}
          />
        </div>
      </div>

      {/* Save Button */}
      <div style={{ marginTop: 30 }}>
        <FormButton onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save Social Links'}
        </FormButton>
      </div>
    </div>
  );
};

export default SocialLinks;
